// Tiny DOM builders shared by the account overlay panels.
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: Partial<HTMLElementTagNameMap[K]> & { testid?: string } = {},
  ...children: (HTMLElement | string)[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  const { testid, ...rest } = props;
  Object.assign(node, rest);
  if (testid) node.dataset.testid = testid;
  node.append(...children);
  return node;
}

export function labeled(text: string, input: HTMLInputElement): HTMLLabelElement {
  return el('label', {}, text, input);
}
